module.exports = __webpack_public_path__ + "assets/media/1.f02f71f1.wav";